import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import EditPageComponent from '../_generic/edit.page.component';
import GlobalRuleListContainer from './define/globalRuleList.container';
import RuleTableComponent from './define/ruleTable.component';
import PreviewTableComponent from './preview/previewTable.component';
import MappingComponent from './mapping/mapping.component';
import EditorContainer from './notes/editor.container';
import SaveSessionButtonContainer from '../session/overview/saveSessionButton.container';
import LoadingComponent from '../common/loading.component';
import { fetchSessionFile, fetchSessionFiles, saveSession, updateFileNotesEditorContent } from '../../store/actions/session.actions';

const tabs = ['Columns', 'Global Rules', 'Mapping', 'Preview', 'Notes'];

class RulesContainer extends React.Component {

  constructor(props) {
    super(props);

    this.handleTabChange = this.handleTabChange.bind(this);

    const tabIndex = tabs.indexOf(this.props.match.params.tab);
    this.state = {
      currentTab: tabIndex < 1 ? 0 : tabIndex,
    };
  }

  async componentDidMount() {
    const { match, fileId} = this.props;
    if (fileId !== match.params.fileId) {
      await this.props.fetchSessionFiles(match.params.sessionId);
      await this.props.fetchSessionFile(match.params.sessionId, match.params.fileId);
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isSaved && prevProps.isSaved) {
      setTimeout(() => {
        if (!this.props.isSaved) {
          this.props.saveSession();
        }
      }, 1000);
    }
  }

  handleTabChange(event, value) {
    const { match, history } = this.props;
    const { tab } = match;
    const tabName = tabs[value];

    if (!tab || tab !== tabName) {
      history.push(`/project/${match.params.sessionId}/file/${match.params.fileId}/${tabName}`);
    }

    this.setState({
      currentTab: value,
    });
  }

  getData() {
    return this.props.data
  }

  render() {
    const {
      fileId,
      isFetchingSession,
      isFetchingSessionFiles,
      isSaved,
      session,
      metadata,
      searchTerm,
      rules,
      data,
    } = this.props;
    if (isFetchingSessionFiles || isFetchingSession || !session || !_.size(metadata)) {
      return <LoadingComponent />;
    }
    return (
      <EditPageComponent
        fileName={session.files[fileId].filename}
        tabs={tabs}
        currentTab={this.state.currentTab}
        changeTab={this.handleTabChange}
        sessionId={session.id}
      >
        {this.state.currentTab === 0 ?
          <RuleTableComponent
            currentFile={session.files[fileId]}
            metadata={metadata}
            rules={rules}
            session={session}
            searchTerm={searchTerm}
          />
          : null}
        {this.state.currentTab === 1 ?
          <GlobalRuleListContainer
            rules={_.pickBy(this.props.rules, rule => !rule.attribute)}
          />
          : null}
        {this.state.currentTab === 2 ?
          <MappingComponent
            metadata={metadata}
          />
          : null}
        {this.state.currentTab === 3 ?
          <PreviewTableComponent
            metadata={metadata}
            data={this.getData()}
          />
          : null}
        {this.state.currentTab === 4 ?
          <EditorContainer
          currentFile={session.files[fileId]}
          session={session}
          editorRawContent={this.props.session.files[this.props.fileId].notesEditorContent}
          />
          : null}
        <SaveSessionButtonContainer isSaved={isSaved} />
      </EditPageComponent>
    );
  }
}

RulesContainer.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  fileId: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  rules: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    attribute: PropTypes.string,
    index: PropTypes.number,
  }).isRequired,
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    format: PropTypes.string,
    mapped: PropTypes.bool,
    custom: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  session: PropTypes.shape({
    id: PropTypes.string,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      virtualFile: PropTypes.bool,
      savedByUser: PropTypes.bool,
      notesEditorContent: PropTypes.string,
    }),
  }),
  isFetchingSession: PropTypes.bool.isRequired,
  isFetchingSessionFiles: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired,
  fetchSessionFile: PropTypes.func.isRequired,
  fetchSessionFiles: PropTypes.func.isRequired,
  saveSession: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  updateFileNotesEditorContent: PropTypes.func.isRequired,
  /* eslint-enable */
};

RulesContainer.defaultProps = {
  session: undefined,
};

const mapStateToProps = ({
  status: {
    isFetchingSession,
    isFetchingSessionFiles,
    isSaved,
    currentSessionId,
    currentFileId,
    searchTerm,
  },
  mutatedData,
  rules: { rules },
  metadata,
  sessions,
}) => ({
  fileId: currentFileId,
  sessionId: currentSessionId,
  isFetchingSession,
  isFetchingSessionFiles,
  isSaved,
  data: mutatedData,
  rules,
  metadata,
  session: sessions[currentSessionId],
  searchTerm,
});

export default withRouter(connect(
  mapStateToProps,
  { fetchSessionFile, fetchSessionFiles, saveSession, updateFileNotesEditorContent },
)(RulesContainer));
